/* eslint-disable react/no-array-index-key */
import React from 'react';

import classes from './styles.module.scss';
import Stage from './Stage';

import { useUserStore } from '../../../../store';

// const stages = ['New', 'Screen', 'Interview', 'Offer', 'Onboard'];

const statuses = {
  Invited: {
    Pending: [
      { stageName: 'New', class: 'pending' },
      { stageName: 'Screen', class: '' },
      { stageName: 'ClientSubmit', class: '' },
      { stageName: 'ClientInterview', class: '' },
      { stageName: 'Interview', class: '' },
      { stageName: 'Offer', class: '' },
      { stageName: 'Onboard', class: '' },
    ],
    Rejected: [
      { stageName: 'New', class: 'rejected' },
      { stageName: 'Screen', class: '' },
      { stageName: 'ClientSubmit', class: '' },
      { stageName: 'ClientInterview', class: '' },
      { stageName: 'Interview', class: '' },
      { stageName: 'Offer', class: '' },
      { stageName: 'Onboard', class: '' },
    ],
    Withdrawn: [
      { stageName: 'New', class: 'rejected' },
      { stageName: 'Screen', class: '' },
      { stageName: 'ClientSubmit', class: '' },
      { stageName: 'ClientInterview', class: '' },
      { stageName: 'Interview', class: '' },
      { stageName: 'Offer', class: '' },
      { stageName: 'Onboard', class: '' },
    ],
    Accepted: [
      { stageName: 'New', class: 'current' },
      { stageName: 'Screen', class: '' },
      { stageName: 'ClientSubmit', class: '' },
      { stageName: 'ClientInterview', class: '' },
      { stageName: 'Interview', class: '' },
      { stageName: 'Offer', class: '' },
      { stageName: 'Onboard', class: '' },
    ],
  },
  New: {
    Pending: [
      { stageName: 'New', class: 'pending' },
      { stageName: 'Screen', class: '' },
      { stageName: 'Interview', class: '' },
      { stageName: 'ClientSubmit', class: '' },
      { stageName: 'ClientInterview', class: '' },
      { stageName: 'Offer', class: '' },
      { stageName: 'Onboard', class: '' },
    ],
    Hire: [
      { stageName: 'New', class: 'pending' },
      { stageName: 'Screen', class: '' },
      { stageName: 'Interview', class: '' },
      { stageName: 'ClientSubmit', class: '' },
      { stageName: 'ClientInterview', class: '' },
      { stageName: 'Offer', class: '' },
      { stageName: 'Onboard', class: '' },
    ],
    Hold: [
      { stageName: 'New', class: 'pending' },
      { stageName: 'Screen', class: '' },
      { stageName: 'Interview', class: '' },
      { stageName: 'ClientSubmit', class: '' },
      { stageName: 'ClientInterview', class: '' },
      { stageName: 'Offer', class: '' },
      { stageName: 'Onboard', class: '' },
    ],
    Rejected: [
      { stageName: 'New', class: 'rejected' },
      { stageName: 'Screen', class: '' },
      { stageName: 'Interview', class: '' },
      { stageName: 'ClientSubmit', class: '' },
      { stageName: 'ClientInterview', class: '' },
      { stageName: 'Offer', class: '' },
      { stageName: 'Onboard', class: '' },
    ],
    Withdrawn: [
      { stageName: 'New', class: 'rejected' },
      { stageName: 'Screen', class: '' },
      { stageName: 'Interview', class: '' },
      { stageName: 'ClientSubmit', class: '' },
      { stageName: 'ClientInterview', class: '' },
      { stageName: 'Offer', class: '' },
      { stageName: 'Onboard', class: '' },
    ],
    Accepted: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: '' },
      { stageName: 'Interview', class: '' },
      { stageName: 'ClientSubmit', class: '' },
      { stageName: 'ClientInterview', class: '' },
      { stageName: 'Offer', class: '' },
      { stageName: 'Onboard', class: '' },
    ],
    Declined: [
      { stageName: 'New', class: 'declined' },
      { stageName: 'Screen', class: '' },
      { stageName: 'Interview', class: '' },
      { stageName: 'ClientSubmit', class: '' },
      { stageName: 'ClientInterview', class: '' },
      { stageName: 'Offer', class: '' },
      { stageName: 'Onboard', class: '' },
    ],
  },
  Screen: {
    Pending: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'pending' },
      { stageName: 'Interview', class: '' },
      { stageName: 'ClientSubmit', class: '' },
      { stageName: 'ClientInterview', class: '' },
      { stageName: 'Offer', class: '' },
      { stageName: 'Onboard', class: '' },
    ],
    Requested: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'requested' },
      { stageName: 'Interview', class: '' },
      { stageName: 'ClientSubmit', class: '' },
      { stageName: 'ClientInterview', class: '' },
      { stageName: 'Offer', class: '' },
      { stageName: 'Onboard', class: '' },
    ],
    Completed: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'current' },
      { stageName: 'Interview', class: '' },
      { stageName: 'ClientSubmit', class: '' },
      { stageName: 'ClientInterview', class: '' },
      { stageName: 'Offer', class: '' },
      { stageName: 'Onboard', class: '' },
    ],
    Passed: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'current' },
      { stageName: 'Interview', class: '' },
      { stageName: 'ClientSubmit', class: '' },
      { stageName: 'ClientInterview', class: '' },
      { stageName: 'Offer', class: '' },
      { stageName: 'Onboard', class: '' },
    ],
    Failed: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'rejected' },
      { stageName: 'Interview', class: '' },
      { stageName: 'ClientSubmit', class: '' },
      { stageName: 'ClientInterview', class: '' },
      { stageName: 'Offer', class: '' },
      { stageName: 'Onboard', class: '' },
    ],
    Rejected: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'rejected' },
      { stageName: 'Interview', class: '' },
      { stageName: 'ClientSubmit', class: '' },
      { stageName: 'ClientInterview', class: '' },
      { stageName: 'Offer', class: '' },
      { stageName: 'Onboard', class: '' },
    ],
    Incomplete: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'rejected' },
      { stageName: 'Interview', class: '' },
      { stageName: 'ClientSubmit', class: '' },
      { stageName: 'ClientInterview', class: '' },
      { stageName: 'Offer', class: '' },
      { stageName: 'Onboard', class: '' },
    ],
    Withdrawn: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'rejected' },
      { stageName: 'Interview', class: '' },
      { stageName: 'ClientSubmit', class: '' },
      { stageName: 'ClientInterview', class: '' },
      { stageName: 'Offer', class: '' },
      { stageName: 'Onboard', class: '' },
    ],
  },
  Interview: {
    Pending: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'pending' },
      { stageName: 'ClientSubmit', class: '' },
      { stageName: 'ClientInterview', class: '' },
      { stageName: 'Offer', class: '' },
      { stageName: 'Onboard', class: '' },
    ],
    ChangeRequested: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'declined' },
      { stageName: 'ClientSubmit', class: '' },
      { stageName: 'ClientInterview', class: '' },
      { stageName: 'Offer', class: '' },
      { stageName: 'Onboard', class: '' },
    ],
    Rescheduled: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'requested' },
      { stageName: 'ClientSubmit', class: '' },
      { stageName: 'ClientInterview', class: '' },
      { stageName: 'Offer', class: '' },
      { stageName: 'Onboard', class: '' },
    ],
    Scheduled: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'requested' },
      { stageName: 'ClientSubmit', class: '' },
      { stageName: 'ClientInterview', class: '' },
      { stageName: 'Offer', class: '' },
      { stageName: 'Onboard', class: '' },
    ],
    InProgress: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'requested' },
      { stageName: 'ClientSubmit', class: '' },
      { stageName: 'ClientInterview', class: '' },
      { stageName: 'Offer', class: '' },
      { stageName: 'Onboard', class: '' },
    ],
    Accepted: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'requested' },
      { stageName: 'ClientSubmit', class: '' },
      { stageName: 'ClientInterview', class: '' },
      { stageName: 'Offer', class: '' },
      { stageName: 'Onboard', class: '' },
    ],
    Declined: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'rejected' },
      { stageName: 'ClientSubmit', class: '' },
      { stageName: 'ClientInterview', class: '' },
      { stageName: 'Offer', class: '' },
      { stageName: 'Onboard', class: '' },
    ],
    Canceled: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'declined' },
      { stageName: 'ClientSubmit', class: '' },
      { stageName: 'ClientInterview', class: '' },
      { stageName: 'Offer', class: '' },
      { stageName: 'Onboard', class: '' },
    ],
    Passed: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'current' },
      { stageName: 'ClientSubmit', class: '' },
      { stageName: 'ClientInterview', class: '' },
      { stageName: 'Offer', class: '' },
      { stageName: 'Onboard', class: '' },
    ],
    Rejected: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'rejected' },
      { stageName: 'ClientSubmit', class: '' },
      { stageName: 'ClientInterview', class: '' },
      { stageName: 'Offer', class: '' },
      { stageName: 'Onboard', class: '' },
    ],
    Withdrawn: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'rejected' },
      { stageName: 'ClientSubmit', class: '' },
      { stageName: 'ClientInterview', class: '' },
      { stageName: 'Offer', class: '' },
      { stageName: 'Onboard', class: '' },
    ],
  },
  ClientSubmit: {
    ClientNotified: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'completed' },
      { stageName: 'ClientSubmit', class: 'current' },
      { stageName: 'ClientInterview', class: '' },
      { stageName: 'Offer', class: '' },
      { stageName: 'Onboard', class: '' },
    ],
    Hire: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'completed' },
      { stageName: 'ClientSubmit', class: 'current' },
      { stageName: 'ClientInterview', class: '' },
      { stageName: 'Offer', class: '' },
      { stageName: 'Onboard', class: '' },
    ],
    Hold: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'completed' },
      { stageName: 'ClientSubmit', class: 'current' },
      { stageName: 'ClientInterview', class: '' },
      { stageName: 'Offer', class: '' },
      { stageName: 'Onboard', class: '' },
    ],
    ClientViewed: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'completed' },
      { stageName: 'ClientSubmit', class: 'current' },
      { stageName: 'ClientInterview', class: '' },
      { stageName: 'Offer', class: '' },
      { stageName: 'Onboard', class: '' },
    ],
    ClientNeedsInfo: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'completed' },
      { stageName: 'ClientSubmit', class: 'current' },
      { stageName: 'ClientInterview', class: '' },
      { stageName: 'Offer', class: '' },
      { stageName: 'Onboard', class: '' },
    ],
    PendingFeedback: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'completed' },
      { stageName: 'ClientSubmit', class: 'current' },
      { stageName: 'ClientInterview', class: '' },
      { stageName: 'Offer', class: '' },
      { stageName: 'Onboard', class: '' },
    ],
    Pending: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'completed' },
      { stageName: 'ClientSubmit', class: 'current' },
      { stageName: 'ClientInterview', class: '' },
      { stageName: 'Offer', class: '' },
      { stageName: 'Onboard', class: '' },
    ],
    Rejected: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'completed' },
      { stageName: 'ClientSubmit', class: 'rejected' },
      { stageName: 'ClientInterview', class: '' },
      { stageName: 'Offer', class: '' },
      { stageName: 'Onboard', class: '' },
    ],
  },
  ClientInterview: {
    Scheduled: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'completed' },
      { stageName: 'ClientSubmit', class: 'completed' },
      { stageName: 'ClientInterview', class: 'requested' },
      { stageName: 'Offer', class: '' },
      { stageName: 'Onboard', class: '' },
    ],
    Hire: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'completed' },
      { stageName: 'ClientSubmit', class: 'completed' },
      { stageName: 'ClientInterview', class: 'requested' },
      { stageName: 'Offer', class: '' },
      { stageName: 'Onboard', class: '' },
    ],
    Hold: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'completed' },
      { stageName: 'ClientSubmit', class: 'completed' },
      { stageName: 'ClientInterview', class: 'requested' },
      { stageName: 'Offer', class: '' },
      { stageName: 'Onboard', class: '' },
    ],
    ClientAcceptedClientInterview: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'completed' },
      { stageName: 'ClientSubmit', class: 'completed' },
      { stageName: 'ClientInterview', class: 'requested' },
      { stageName: 'Offer', class: '' },
      { stageName: 'Onboard', class: '' },
    ],
    JobseekerAcceptedClientInterview: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'completed' },
      { stageName: 'ClientSubmit', class: 'completed' },
      { stageName: 'ClientInterview', class: 'requested' },
      { stageName: 'Offer', class: '' },
      { stageName: 'Onboard', class: '' },
    ],
    BothAcceptedClientInterview: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'completed' },
      { stageName: 'ClientSubmit', class: 'completed' },
      { stageName: 'ClientInterview', class: 'requested' },
      { stageName: 'Offer', class: '' },
      { stageName: 'Onboard', class: '' },
    ],
    Canceled: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'completed' },
      { stageName: 'ClientSubmit', class: 'completed' },
      { stageName: 'ClientInterview', class: 'declined' },
      { stageName: 'Offer', class: '' },
      { stageName: 'Onboard', class: '' },
    ],
    Declined: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'completed' },
      { stageName: 'ClientSubmit', class: 'completed' },
      { stageName: 'ClientInterview', class: 'rejected' },
      { stageName: 'Offer', class: '' },
      { stageName: 'Onboard', class: '' },
    ],
    Accepted: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'completed' },
      { stageName: 'ClientSubmit', class: 'completed' },
      { stageName: 'ClientInterview', class: 'current' },
      { stageName: 'Offer', class: '' },
      { stageName: 'Onboard', class: '' },
    ],
    Requested: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'completed' },
      { stageName: 'ClientSubmit', class: 'completed' },
      { stageName: 'ClientInterview', class: 'requested' },
      { stageName: 'Offer', class: '' },
      { stageName: 'Onboard', class: '' },
    ],
    Rescheduled: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'completed' },
      { stageName: 'ClientSubmit', class: 'completed' },
      { stageName: 'ClientInterview', class: 'requested' },
      { stageName: 'Offer', class: '' },
      { stageName: 'Onboard', class: '' },
    ],
    PendingFeedback: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'completed' },
      { stageName: 'ClientSubmit', class: 'completed' },
      { stageName: 'ClientInterview', class: 'requested' },
      { stageName: 'Offer', class: '' },
      { stageName: 'Onboard', class: '' },
    ],
    Passed: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'completed' },
      { stageName: 'ClientSubmit', class: 'completed' },
      { stageName: 'ClientInterview', class: 'current' },
      { stageName: 'Offer', class: '' },
      { stageName: 'Onboard', class: '' },
    ],
    Rejected: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'completed' },
      { stageName: 'ClientSubmit', class: 'completed' },
      { stageName: 'ClientInterview', class: 'rejected' },
      { stageName: 'Offer', class: '' },
      { stageName: 'Onboard', class: '' },
    ],
    Reinstated: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'completed' },
      { stageName: 'ClientSubmit', class: 'completed' },
      { stageName: 'ClientInterview', class: 'pending' },
      { stageName: 'Offer', class: '' },
      { stageName: 'Onboard', class: '' },
    ],
  },
  Offer: {
    Pending: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'completed' },
      { stageName: 'ClientSubmit', class: 'completed' },
      { stageName: 'ClientInterview', class: 'completed' },
      { stageName: 'Offer', class: 'pending' },
      { stageName: 'Onboard', class: '' },
    ],
    Offered: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'completed' },
      { stageName: 'Offer', class: 'requested' },
      { stageName: 'ClientSubmit', class: 'completed' },
      { stageName: 'ClientInterview', class: 'completed' },
      { stageName: 'Onboard', class: '' },
    ],
    Accepted: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'completed' },
      { stageName: 'ClientSubmit', class: 'completed' },
      { stageName: 'ClientInterview', class: 'completed' },
      { stageName: 'Offer', class: 'current' },
      { stageName: 'Onboard', class: '' },
    ],
    CounterAccepted: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'completed' },
      { stageName: 'ClientSubmit', class: 'completed' },
      { stageName: 'ClientInterview', class: 'completed' },
      { stageName: 'Offer', class: 'requested' },
      { stageName: 'Onboard', class: '' },
    ],
    Rejected: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'completed' },
      { stageName: 'ClientSubmit', class: 'completed' },
      { stageName: 'ClientInterview', class: 'completed' },
      { stageName: 'Offer', class: 'rejected' },
      { stageName: 'Onboard', class: '' },
    ],
    Declined: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'completed' },
      { stageName: 'ClientSubmit', class: 'completed' },
      { stageName: 'ClientInterview', class: 'completed' },
      { stageName: 'Offer', class: 'rejected' },
      { stageName: 'Onboard', class: '' },
    ],
    Withdrawn: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'completed' },
      { stageName: 'ClientSubmit', class: 'completed' },
      { stageName: 'ClientInterview', class: 'completed' },
      { stageName: 'Offer', class: 'rejected' },
      { stageName: 'Onboard', class: '' },
    ],
    Countered: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'completed' },
      { stageName: 'ClientSubmit', class: 'completed' },
      { stageName: 'ClientInterview', class: 'completed' },
      { stageName: 'Offer', class: 'declined' },
      { stageName: 'Onboard', class: '' },
    ],
  },
  Onboard: {
    Scheduled: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'completed' },
      { stageName: 'ClientSubmit', class: 'completed' },
      { stageName: 'ClientInterview', class: 'completed' },
      { stageName: 'Offer', class: 'completed' },
      { stageName: 'Onboard', class: 'requested' },
    ],
    Rescheduled: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'completed' },
      { stageName: 'ClientSubmit', class: 'completed' },
      { stageName: 'ClientInterview', class: 'completed' },
      { stageName: 'Offer', class: 'completed' },
      { stageName: 'Onboard', class: 'requested' },
    ],
    Pending: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'completed' },
      { stageName: 'ClientSubmit', class: 'completed' },
      { stageName: 'ClientInterview', class: 'completed' },
      { stageName: 'Offer', class: 'completed' },
      { stageName: 'Onboard', class: 'pending' },
    ],
    Onboarded: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'completed' },
      { stageName: 'ClientSubmit', class: 'completed' },
      { stageName: 'ClientInterview', class: 'completed' },
      { stageName: 'Offer', class: 'completed' },
      { stageName: 'Onboard', class: 'current' },
    ],
    Joined: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'completed' },
      { stageName: 'ClientSubmit', class: 'completed' },
      { stageName: 'ClientInterview', class: 'completed' },
      { stageName: 'Offer', class: 'completed' },
      { stageName: 'Onboard', class: 'completed' },
    ],
    Accepted: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'completed' },
      { stageName: 'ClientSubmit', class: 'completed' },
      { stageName: 'ClientInterview', class: 'completed' },
      { stageName: 'Offer', class: 'completed' },
      { stageName: 'Onboard', class: 'current' },
    ],
    StartDateSet: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'completed' },
      { stageName: 'ClientSubmit', class: 'completed' },
      { stageName: 'ClientInterview', class: 'completed' },
      { stageName: 'Offer', class: 'completed' },
      { stageName: 'Onboard', class: 'current' },
    ],
    StartConfirmed: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'completed' },
      { stageName: 'ClientSubmit', class: 'completed' },
      { stageName: 'ClientInterview', class: 'completed' },
      { stageName: 'Offer', class: 'completed' },
      { stageName: 'Onboard', class: 'current' },
    ],
    StartDeclined: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'completed' },
      { stageName: 'ClientSubmit', class: 'completed' },
      { stageName: 'ClientInterview', class: 'completed' },
      { stageName: 'Offer', class: 'completed' },
      { stageName: 'Onboard', class: 'rejected' },
    ],
    Declined: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'completed' },
      { stageName: 'ClientSubmit', class: 'completed' },
      { stageName: 'ClientInterview', class: 'completed' },
      { stageName: 'Offer', class: 'completed' },
      { stageName: 'Onboard', class: 'rejected' },
    ],
    NoShow: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'completed' },
      { stageName: 'ClientSubmit', class: 'completed' },
      { stageName: 'ClientInterview', class: 'completed' },
      { stageName: 'Offer', class: 'completed' },
      { stageName: 'Onboard', class: 'rejected' },
    ],
    Canceled: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'completed' },
      { stageName: 'ClientSubmit', class: 'completed' },
      { stageName: 'ClientInterview', class: 'completed' },
      { stageName: 'Offer', class: 'completed' },
      { stageName: 'Onboard', class: 'declined' },
    ],
    Rejected: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'completed' },
      { stageName: 'ClientSubmit', class: 'completed' },
      { stageName: 'ClientInterview', class: 'completed' },
      { stageName: 'Offer', class: 'completed' },
      { stageName: 'Onboard', class: 'rejected' },
    ],
    ChangeRequested: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'completed' },
      { stageName: 'ClientSubmit', class: 'completed' },
      { stageName: 'ClientInterview', class: 'completed' },
      { stageName: 'Offer', class: 'completed' },
      { stageName: 'Onboard', class: 'declined' },
    ],
    Withdrawn: [
      { stageName: 'New', class: 'completed' },
      { stageName: 'Screen', class: 'completed' },
      { stageName: 'Interview', class: 'completed' },
      { stageName: 'ClientSubmit', class: 'completed' },
      { stageName: 'ClientInterview', class: 'completed' },
      { stageName: 'Offer', class: 'completed' },
      { stageName: 'Onboard', class: 'rejected' },
    ],
  },
};

export default function HiringStages({ status, subStatus, hasAssessment }) {
  const screeningAvailable = useUserStore((state) => state.screeningAvailable);
  const isClient = useUserStore((state) => state.isClient);

  if (isClient) {
    let stageIndex = 0;
    return (
      <div className={classes.HiringStages}>
        {statuses[status]?.[subStatus]?.map((stage, index) => {
          if (
            stage.stageName === 'New' ||
            stage.stageName === 'Screen' ||
            stage.stageName === 'Interview'
          ) {
            return null;
          }

          if (index !== 0) {
            stageIndex = index - 3;
          }

          console.log(stageIndex);
          console.log(index);
          return (
            <Stage
              key={stageIndex}
              stageName={stage.stageName}
              index={stageIndex}
              className={stage.class}
            />
          );
        })}
      </div>
    );
  }

  if (!hasAssessment || !screeningAvailable) {
    let stageIndex = 0;
    return (
      <div className={classes.HiringStages}>
        {statuses[status]?.[subStatus]?.map((stage, index) => {
          if (stage.stageName === 'Screen') {
            return null;
          }

          if (index !== 0) {
            stageIndex += 1;
          }
          return (
            <Stage
              key={stageIndex}
              stageName={stage.stageName}
              index={stageIndex}
              className={stage.class}
            />
          );
        })}
      </div>
    );
  }

  return (
    <div className={classes.HiringStages}>
      {statuses[status]?.[subStatus]?.map((stage, index) => {
        return (
          <Stage
            key={index}
            stageName={stage.stageName}
            index={index}
            className={stage.class}
          />
        );
      })}
    </div>
  );
}
